import React, { ReactNode } from "react";
import { AuthProvider } from "react-oidc-context";
import config from "./config";

const VendorProvider: React.FC<{ children?: ReactNode }> = ({ children }) => {
	return <AuthProvider {...config}>{children}</AuthProvider>;
};

export default VendorProvider;
